/* eslint-disable no-unused-vars */
import dynamic from 'next/dynamic'
import cn from 'classnames'
import s from './Header.module.scss'

const BurgerMenu = dynamic(() => import('./BurgerMenu'))

interface MobileMenuProps {
  showMenu: boolean
  toggleMenu: () => void
  userData: any
  setUserData: (data: any) => void
  dispatch: any
  state: any
}

export default function MobileMenu({
  showMenu,
  toggleMenu,
  userData,
  setUserData,
  dispatch,
  state,
}: MobileMenuProps) {
  return (
    <>
      {/* burger menu */}
      <div
        onClick={toggleMenu}
        className={cn(s.burger, showMenu ? s.close : s.open)}
      />

      {showMenu && (
        <BurgerMenu
          userData={userData}
          userType={userData?.type}
          setUserData={setUserData}
          dispatch={dispatch}
          state={state}
        />
      )}
    </>
  )
}
